import { Component } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'ta-login-o2-redirect',
  templateUrl: './login-o2-redirect.component.html',                //  GECO-15436
})
export class LoginO2RedirectComponent {

  readonly o2Url = environment.o2Url;

  goToO2(): void {
    window.location.href = this.o2Url;
  }

}